import { useState } from "react";
import Logo from "../../components/ui/Logo";
import { apiBaseUrl } from "../../config/api";
import { loginAdmin } from "../../services/adminApi";
import { setToken } from "../../services/tokenStorage";

function AdminLogin({ onAuthenticated }) {
  const [credentials, setCredentials] = useState({ email: "", password: "" });
  const [status, setStatus] = useState({ type: "idle", message: "" });

  const updateField = (event) => {
    setCredentials((current) => ({
      ...current,
      [event.target.name]: event.target.value,
    }));
  };

  const submitLogin = async (event) => {
    event.preventDefault();
    setStatus({ type: "loading", message: "Overuji pristup..." });

    try {
      const response = await loginAdmin(credentials);
      if (!response?.token) {
        throw new Error("API nevratilo prihlasovaci token.");
      }
      setToken(response.token);
      onAuthenticated(response.user);
    } catch (error) {
      setStatus({ type: "error", message: error.message });
    }
  };

  return (
    <section className="page-section">
      <div className="shell">
        <div className="mx-auto max-w-md">
          <div className="mb-8 flex justify-center">
            <Logo />
          </div>
          <form className="card p-6" onSubmit={submitLogin}>
            <h1 className="text-2xl font-extrabold tracking-tight text-white">Prihlaseni do administrace</h1>
            <p className="mt-2 text-sm leading-6 text-slate-300">
              Pripojeno na API: <span className="font-semibold text-cyan-200">{apiBaseUrl}</span>
            </p>

            <div className="mt-6 grid gap-4">
              <label className="grid gap-1.5 text-sm font-medium text-slate-200">
                E-mail
                <input className="input" name="email" type="email" value={credentials.email} onChange={updateField} required />
              </label>
              <label className="grid gap-1.5 text-sm font-medium text-slate-200">
                Heslo
                <input className="input" name="password" type="password" value={credentials.password} onChange={updateField} required />
              </label>
              {status.message && (
                <p className={`text-sm ${status.type === "error" ? "text-red-300" : "text-cyan-200"}`}>
                  {status.message}
                </p>
              )}
              <button type="submit" className="btn-primary w-full" disabled={status.type === "loading"}>
                Prihlasit
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}

export default AdminLogin;
